
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tagItems",
      function () {
        return require("private-next-pages/tagItems.js");
      }
    ]);
  